(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categories-bar"] && !Shopify.designMode) return;
  try {
    
  /*
   * Keeps the sticky offset of the section wrapper level with the bottom of the header. CSS does
   * the sticking itself, which is what stops the bar from travelling above the hero banner.
   */
  class CategoriesBar extends HTMLElement {
    connectedCallback() {
      this.section = this.closest('.shopify-section');
      if (!this.section) return;

      this.siteHeader = document.getElementById('site-header');
      this.frame = null;
      this.offset = null;
      this.naturalTop = this.measureNaturalTop();

      this.onScroll = this.onScroll.bind(this);
      this.onResize = this.onResize.bind(this);

      window.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onResize);
      window.addEventListener('load', this.onResize);

      this.update();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onResize);
      window.removeEventListener('load', this.onResize);
      if (this.frame) cancelAnimationFrame(this.frame);
    }

    /*
     * A stuck element reports its shifted position rather than its position in the flow, so
     * stickiness is switched off for the moment the measurement is taken.
     */
    measureNaturalTop() {
      const inlinePosition = this.section.style.position;
      this.section.style.position = 'static';
      const top = Math.round(this.section.getBoundingClientRect().top + window.pageYOffset);
      this.section.style.position = inlinePosition;
      return top;
    }

    /*
     * Bottom edge of the header while it is held at the top of the viewport. Resolves to 0 once
     * the header has scrolled away or been hidden by the on-scroll-up sticky behaviour, so the
     * bar takes its place at the top of the viewport.
     */
    get headerOffset() {
      if (!this.siteHeader) return 0;
      const { bottom, height } = this.siteHeader.getBoundingClientRect();
      return Math.max(0, Math.min(Math.round(bottom), Math.round(height)));
    }

    /*
     * Scroll position at which the bar meets the header. The transparent header reads this so it
     * turns solid at the same moment the bar settles beneath it.
     */
    get stickyThreshold() {
      const headerHeight = this.siteHeader ? this.siteHeader.offsetHeight : 0;
      return Math.max(0, this.naturalTop - headerHeight);
    }

    onScroll() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    onResize() {
      this.naturalTop = this.measureNaturalTop();
      this.update();
    }

    update() {
      const offset = this.headerOffset;
      if (offset === this.offset) return;

      this.offset = offset;
      this.section.style.setProperty('--categories-bar-top', `${offset}px`);
    }
  }

  if (!customElements.get('categories-bar')) {
    customElements.define('categories-bar', CategoriesBar);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
